import { Alert } from "antd";

export interface ModalErrorAlertProps {
  readonly message?: string | null;
}

// Single place for modal error styling/placement.
function ModalErrorAlert(props: ModalErrorAlertProps) {
  if (!props.message) return null;
  return <Alert className="mb-2" message={props.message} type="error" />;
}

export default ModalErrorAlert;
